export interface IStatus {
  id?: number;
  status?: string;
  class?: string;
  number?: number;
  selected?: boolean;
  code: string;
  color?: string;
  borderColor?: string;
  label?: string;
  value?: string;
  outline?: boolean;
  itemStyle?: { color?: string; borderColor?: string; borderWidth?: number };
}
